import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Header } from "./components/Header";

export default function Dashboard({ items, itemsb }) {
  return (
    <div className="app-container">
      <div className="container-fluid">
        <main className="content">
          <Header />

          <div className="row" style={{ marginTop: "30px" }}>
            <div className="col-md-3">
              <p>
                Visit <b>Product A</b> or <b>B</b> by clicking the link below
              </p>
              <Link to="/producta" className="btn btn-info">
                Product A
              </Link>
              <br />
              <Link
                to="/productb"
                className="btn btn-warning"
                style={{ marginTop: "20px" }}
              >
                Product B
              </Link>
            </div>
            <div className="col-md-9"></div>
          </div>
        </main>
        {/* <Footer /> */}
      </div>
    </div>
  );
}
